import { useForm, Controller } from 'react-hook-form';

const RejectChangeRequestModal = ({
    modalOpen,
    setModalOpen,
    onConfirm,
    hasAchDocument = false,
}: {
    modalOpen: boolean;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirm?: (reason: string) => void;
    hasAchDocument?: boolean;
}) => {
    const { register, handleSubmit, formState, reset } = useForm({
        defaultValues: {
            note: '',
        },
    });

    const { isSubmitting } = formState;

    const onSubmit = async (data: any) => {
        if (onConfirm) {
            onConfirm(data.note);
        }
        reset({ note: '' });
        setModalOpen(false);
    };

    return (
        <>
            {modalOpen && (
                <div
                    className='fixed inset-0 z-[99999] flex items-center justify-center bg-black bg-opacity-75'
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'
                    >
                        <div className='p-7'>
                            <h2 className='mb-4 text-3xl font-semibold'>
                                Reject Vendor Change Requests
                            </h2>
                            <p>
                                Please provide a reason as to why you are
                                rejecting this client's change request.
                            </p>
                            {hasAchDocument && (
                                <p className='mt-4 font-bold text-danger'>
                                    The uploaded ACH document will be removed
                                    once you reject. If you need a copy, cancel
                                    and download it first.
                                </p>
                            )}

                            <div className='mt-6'>
                                <label className='block font-bold'>
                                    Reason for Rejection
                                    <span className='text-red'>*</span>
                                </label>
                                <textarea
                                    className='w-full resize-none rounded border p-2'
                                    placeholder='Text'
                                    rows={6}
                                    required={true}
                                    aria-required={true}
                                    {...register('note')}
                                />
                            </div>
                            <div className='flex gap-[16px]'>
                                <button
                                    onClick={() => setModalOpen(false)}
                                    type='button'
                                    className='mt-[30px]  rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#E6F7F8] hover:bg-[#E6F7F8]'
                                >
                                    Cancel
                                </button>
                                <button
                                    type='button'
                                    className={`mt-[30px] rounded-full border-[2px] border-danger bg-danger px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-white  transition-colors duration-500 ${isSubmitting
                                        ? 'cursor-not-allowed opacity-50'
                                        : 'hover:border-[#E6F7F8] hover:bg-[#E6F7F8] hover:text-black'
                                        }`}
                                    onClick={handleSubmit(onSubmit)}
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Saving...' : 'Reject'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default RejectChangeRequestModal;
